export default __webpack_public_path__ + "static/media/camera.ce30d409.png";